import {
  BETTER_DOC_CONSULTATION_QUESTIONS,
  type BetterDocConsultationAnswers,
  type BetterDocConsultationQuestion,
  type BetterDocConsultationQuestionId,
} from "@/modules/patients/detail/better-doc/de/lib/better-doc-consultation-questionnaire-definition"
import { getDeBetterDocSubSpecialties } from "@/modules/patients/detail/better-doc/de/lib/de-better-doc-sub-specialties"
import type { BetterDocSpecialty } from "@/modules/patients/detail/better-doc/lib/better-doc-sub-specialties"

export const getVisibleQuestions = (
  answers: BetterDocConsultationAnswers,
  specialtyName: BetterDocSpecialty | undefined,
): readonly BetterDocConsultationQuestion[] => {
  const visibleQuestions: BetterDocConsultationQuestion[] = []
  const visibleAnswers: BetterDocConsultationAnswers = {}
  const hasDeSubSpecialties = getDeBetterDocSubSpecialties(specialtyName).length > 0

  for (const question of BETTER_DOC_CONSULTATION_QUESTIONS) {
    const isSubSpecialtyWithoutOptions = question.id === "subSpecialty" && !hasDeSubSpecialties
    if (!isSubSpecialtyWithoutOptions && question.isShown(visibleAnswers, specialtyName)) {
      visibleQuestions.push(question)
      visibleAnswers[question.id] = answers[question.id]
    }
  }

  return visibleQuestions
}

export const getDependentQuestions = (
  questionId: BetterDocConsultationQuestionId,
): readonly BetterDocConsultationQuestionId[] => {
  const dependentIds = new Set<BetterDocConsultationQuestionId>([questionId])

  for (const question of BETTER_DOC_CONSULTATION_QUESTIONS) {
    if (question.dependsOn.some((dependencyId) => dependentIds.has(dependencyId))) {
      dependentIds.add(question.id)
    }
  }

  return BETTER_DOC_CONSULTATION_QUESTIONS.filter(
    (question) => question.id !== questionId && dependentIds.has(question.id),
  ).map((question) => question.id)
}
